import { render, staticRenderFns } from "./SidebarConfiguration.vue?vue&type=template&id=672e844e&"
import script from "./SidebarConfiguration.vue?vue&type=script&lang=js&"
export * from "./SidebarConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SidebarConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports